import { FREE_TRIAL_NUDGE_LOCAL_STORAGE_KEY } from './constants';

type FreeTrialNudgeStorage = {
  dismissCount: number; // how many times user dismissed in current 15-day window
  lastShown: number; // timestamp of the last time banner was shown
  startDate: number; // timestamp when the nudge started showing
};

/**
 * Determines whether the free trial nudge  should be shown
 */
export function shouldShowFreeTrialNudge(userID: string): boolean {
  if (!userID) return false;
  const now = new Date().getTime();
  const key = `${FREE_TRIAL_NUDGE_LOCAL_STORAGE_KEY}_${userID}`;
  const stored = localStorage.getItem(key);
  const TWO_MONTHS = 60 * 24 * 60 * 60 * 1000; // 2 months in ms
  const FIFTEEN_DAYS = 15 * 24 * 60 * 60 * 1000; // 15 days in ms

  if (stored) {
    const data = JSON.parse(stored) as FreeTrialNudgeStorage;
    // Don't show trial nudge after 2 months from trial start date
    if (now - data.startDate > TWO_MONTHS) {
      return false;
    }
    // Reset dismiss count if 15-day window has passed since lastShown
    if (now - data.lastShown > FIFTEEN_DAYS) {
      data.dismissCount = 0;
      data.lastShown = now;
      localStorage.setItem(key, JSON.stringify(data));
      return true;
    }

    return data.dismissCount < 3;
  } else {
    const intializeLocalStorageData = { dismissCount: 0, lastShown: now, startDate: new Date().getTime() };
    localStorage.setItem(key, JSON.stringify(intializeLocalStorageData));
    return true;
  }
}

/**
 * Call this function when user dismisses the tooltip
 */
export function recordFreetrialNudgeDismiss(userID: string) {
  const key = `${FREE_TRIAL_NUDGE_LOCAL_STORAGE_KEY}_${userID}`;
  const stored = localStorage.getItem(key);
  if (!stored) return;

  const data: FreeTrialNudgeStorage = JSON.parse(stored);
  data.dismissCount += 1;
  data.lastShown = Date.now();
  localStorage.setItem(key, JSON.stringify(data));
}
